module.exports = Object.freeze({
    reportTypeIds: {
        PRO: 1,
        MASTER_PERFORMANCE: 2,
        PUBLISHER_ADMIN: 3,
        LABEL_DISTRIBUTOR: 4
    }
});
